import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";

PlusMinusControl.propTypes = {
  style: PropTypes.object,
  handleAddClick: PropTypes.func,
  handleMinusClick: PropTypes.func,
  quantity: PropTypes.number,
  isAddDisabled: PropTypes.bool,
  isMinusDisabled: PropTypes.bool,
};

export default function PlusMinusControl(props) {
  const { style, handleAddClick, handleMinusClick, quantity, isAddDisabled, isMinusDisabled } = props;
  return (
    <ControlWrapper style={style}>
      <ControlButton
        onClick={() => {
          if (!isMinusDisabled) handleMinusClick();
        }}
        disabled={isMinusDisabled || quantity == 0}
      >
        <RemoveCircleOutlineRoundedIcon />
      </ControlButton>
      <QuantityField type="text" value={quantity} readOnly min="0" />
      {
        <ControlButton
          onClick={() => {
            if (!isAddDisabled) handleAddClick();
          }}
          disabled={isAddDisabled}
        >
          <AddCircleOutlineRoundedIcon />
        </ControlButton>
      }
    </ControlWrapper>
  );
}

const ControlWrapper = styled.div`
  transition: background-color 0.5s ease;
  text-align: center;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
`;

const ControlButton = styled.span`
  background: #fff;
  font-size: 1.5em;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  text-align: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
  line-height: 100%;
  &:hover,
  :active,
  :focus {
    text-decoration: none;
  }
  & svg {
    fill: ${(props) => (props.disabled ? "#d3d3d3" : props.fillColor)};
    transition: fill 0.3s ease;
  }

  @media only screen and (min-device-width: 812px) {
    &:not([disabled]):hover {
      text-decoration: none;
      & svg {
        fill: var(--secondary-brand-color);
      }
    }
  }
`;

const QuantityField = styled.input`
  border: none !important;
  background: transparent !important;
  color: var(--body-text-color) !important;
  -webkit-appearance: none !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 45px !important;
  -moz-appearance: textfield !important;
  text-align: center !important;
  height: auto !important;
  line-height: 1 !important;
`;
